<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :btn-loading="isCheckingSealedUnitCount || isSubmitting"
    :submit-btn-disabled="isCheckingSealedUnitCount || isSubmitting"
    :max-width="1000"
  >
    <template slot="header">
      <span>{{ item.id ? `Update Record #${item.id}` : 'Create New Record' }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          class="pb-0"
          cols="4"
        >
          <inventory-class-select-element
            v-model="item.inventory_class_id"
            :is-required="true"
            :is-commercial="true"
            :readonly="true"
            :disabled="true"
          />
        </v-col>
        <v-col cols="8">
          <v-autocomplete
						attach
            v-model="item.location_id"
            :items="locations"
            item-text="name"
            item-value="id"
            label="Location"
            clearable
            :rules="[(v) => !!v || 'Location is required']"
          >
            <template slot="label">
              Location<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="pt-0"
        >
          <v-autocomplete
						attach
            v-model="item.job_id"
            :items="jobs"
            :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
            item-value="id"
            :no-data-text="!item.inventory_class_id ? 'Select an Inventory Class first' : 'No data available'"
            :rules="[(v) => !!v || 'Project/Job is required']"
            :disabled="isDisabled || item.id != 0"
            clearable
            :loading="loadingJob"
          >
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                v-if="item && (item.sub_class_color || item.sub_class_name)"
                small
                :color="item.sub_class_color"
                text-color="white"
                class="mr-2"
              >
                {{ item.sub_class_name }}
              </v-chip>
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #item="{ item }">
              <v-chip
                v-if="item && (item.sub_class_color || item.sub_class_name)"
                small
                :color="item.sub_class_color"
                text-color="white"
                class="mr-2"
              >
                {{ item.sub_class_name }}
              </v-chip>
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <template
              v-if="loadingJob"
              #label
            >
              Loading Jobs...
            </template>
            <template
              v-else
              #label
            >
              Project/Job<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <!-- <v-col
          cols="auto"
          class="text-end pb-0 pt-6 pl-0 pr-0"
        >
          <v-btn
            v-if="!item.id"
            color="primary"
            outlined
            small
            @click="openJobForm()"
          >
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn
            v-else
            color="primary"
            outlined
            small
            @click="openUpdateJobForm()"
          >
            <v-row>
              <v-col
                cols="auto"
                class="pr-0 pl-2"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-col>
              <v-col
                cols="auto"
                class="pl-1"
              >
                <span style="font-size: 15px;">
                  EDIT</span>
              </v-col>
            </v-row>
          </v-btn>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col
          v-if="isCommercialDoors"
          cols="3"
        >
          <v-text-field
            v-model="item.door_count"
            type="number"
            disabled
            label="Door Count"
          >
          </v-text-field>
        </v-col>
        <v-col
          v-if="isCommercialWindows"
          cols="3"
        >
          <v-text-field
            v-model="item.window_count"
            type="number"
            disabled
            label="Window Count"
          >
          </v-text-field>
        </v-col>
        <v-col
          v-if="isCommercialWindows"
          cols="3"
        >
          <v-text-field
            v-model="item.window_vertical_count"
            type="number"
            disabled
            label="Window Verticals"
          >
          </v-text-field>
        </v-col>
        <v-col
          v-if="isCommercialWindows"
          cols="3"
        >
          <v-text-field
            v-model="item.window_horizontal_count"
            type="number"
            disabled
            label="Window Horizontals"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="3"
        >
          <v-text-field
            v-model="item.total_release_qty"
            disabled
            label="Total Release Qty"
            type="number"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="!isJobManual()"
          cols="3"
        >
          <v-autocomplete
						attach
            v-model="item.sp_po_number"
            label="SP PO#"
            :items="spPoNumbers"
            :loading="loadingSpPoNumbers"
            clearable
          >
            <template slot="label">
              SP PO#
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <v-text-field
            v-model="item.sp_po_number"
            clearable
          >
            <template slot="label">
              SP PO#
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="3"
        >
          <v-select
            v-model="item.sp_note_status_id"
            label="SP PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            :disabled="!item.sp_po_number"
            clearable
            :menu-props="{ offsetY: true, attach: true }"
          >
            <template slot="label">
              SP PO# Glass Note
            </template>
          </v-select>
        </v-col>
        <v-col
          v-if="!isJobManual()"
          cols="3"
        >
          <v-autocomplete
						attach
            v-model="item.su_po_number"
            label="S/U PO#"
            :items="suPoNumbers"
            :loading="loadingSuPoNumbers"
            :auto-select-first="true"
            clearable
          >
            <template slot="label">
              S/U PO#
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <v-text-field
            v-model="item.su_po_number"
            clearable
          >
            <template slot="label">
              S/U PO#
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="3"
        >
          <v-select
            v-model="item.su_note_status_id"
            label="SP PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            :disabled="!item.su_po_number"
            clearable
            :menu-props="{ offsetY: true, attach: true }"
          >
            <template slot="label">
              SU PO# Glass Note
            </template>
          </v-select>
        </v-col>
        <v-col
          v-if="!isJobManual()"
          cols="3"
        >
          <v-autocomplete
						attach
            v-model="item.sg_po_number"
            label="SG PO#"
            :items="sgPoNumbers"
            :loading="loadingSgPoNumbers"
            clearable
          >
            <template slot="label">
              SG PO#
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <v-text-field
            v-model="item.sg_po_number"
            clearable
          >
            <template slot="label">
              SG PO#
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="3"
        >
          <v-select
            v-model="item.sg_note_status_id"
            label="SG PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            :disabled="!item.sg_po_number"
            clearable
            :menu-props="{ offsetY: true, attach: true }"
          >
            <template slot="label">
              SG PO# Glass Note
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row v-if="item.sp_note_status_id === noteStatusIdShort || item.su_note_status_id === noteStatusIdShort || item.sg_note_status_id === noteStatusIdShort">
        <v-col
          v-if="item.sp_note_status_id === noteStatusIdShort"
          cols="3"
          class="pt-0"
        >
          <v-text-field
            v-model="item.sp_note"
            label="SP PO# Missing"
            type="number"
            \min="0"
          />
        </v-col>
        <v-col
          v-if="item.su_note_status_id === noteStatusIdShort"
          class="pt-0"
          cols="3"
        >
          <v-text-field
            v-model="item.su_note"
            label="S/U PO# Missing"
            type="number"
            min="0"
          />
        </v-col>
        <v-col
          v-if="item.sg_note_status_id === noteStatusIdShort"
          class="pt-0"
          cols="3"
        >
          <v-text-field
            v-model="item.sg_note"
            label="SG PO# Missing"
            type="number"
            min="0"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
        >
          <v-menu
            ref="menuCompletionDate"
            v-model="dateMenuCompletionDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="item.production_completion_date"
                readonly
                append-icon="mdi-calendar"
                v-bind="attrs"
                :rules="productionCompletionDateRules"
                :disabled="isDisabled"
                v-on="on"
                @change="$refs.menuCompletionDate.save(item.production_completion_date)"
              >
                <template slot="label">
                  Production Date<RedAsterisk />
                </template>
              </v-text-field>
            </template>
            <business-date-picker
              v-model="item.production_completion_date"
              no-title
              scrollable
              :min="getMinDateProd()"
              @input="onProductionCompletionDateChange"
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="item.production_completion_date = null; resetSealedUnitOverbookedValidation()"
              >
                Clear
              </v-btn>
            </business-date-picker>
          </v-menu>
        </v-col>
        <!-- <v-col cols="3">
          <v-text-field
            v-model="item.production_completion_time"
            type="time"
            :rules="[(v) => !!v || 'Production Completion Time is required']"
          >
            <template slot="label">
              Production Time<RedAsterisk />
            </template>
          </v-text-field>
        </v-col> -->
        <!-- <v-col
          cols="3"
        >
          <v-text-field
            v-model="item.glass_required_by"
            label="Glass Req. by"
            readonly
            append-icon="mdi-calendar"
          />
        </v-col> -->
        <v-col
          cols="9"
          class="d-flex align-start"
        >
          <div class="commercial-schedule-glass-required-by-field">
            <v-menu
              ref="menuGlassRequiredBy"
              v-model="dateMenuRequiredBy"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="item.glass_required_by"
                  readonly
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  :rules="glassRequiredByRules"
                  :error="isSealedUnitOverbooked"
                  :error-messages="sealedUnitOverbookedErrorMessages"
                  :disabled="isDisabled"
                  v-on="on"
                  @change="$refs.menuGlassRequiredBy.save(item.glass_required_by)"
                >
                  <template slot="label">
                    Glass Req. By<RedAsterisk />
                  </template>
                </v-text-field>
              </template>
              <business-date-picker
                v-model="item.glass_required_by"
                no-title
                scrollable
                :min="getMinRequiredByDate()"
                @input="onGlassRequiredByDateChange"
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="item.glass_required_by = null; resetSealedUnitOverbookedValidation()"
                >
                  Clear
                </v-btn>
              </business-date-picker>
            </v-menu>
          </div>
          <div
            v-if="sealedUnitStatusChipMessage"
            :class="['sealed-unit-status-chip ml-3 mt-3', sealedUnitStatusChipClass]"
          >
            <v-icon
              small
              class="sealed-unit-status-chip__icon"
            >
              {{ sealedUnitStatusChipIcon }}
            </v-icon>
            <span>{{ sealedUnitStatusChipMessage }}</span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
        >
          <v-menu
            ref="menuShipDate"
            v-model="dateMenuShipDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="item.planned_ship_date"
                readonly
                append-icon="mdi-calendar"
                v-bind="attrs"
                :rules="[(v) => !!v || 'Ship Date is required']"
                :disabled="isDisabled"
                v-on="on"
                @change="$refs.menuShipDate.save(item.planned_ship_date)"
              >
                <template slot="label">
                  Ship Date<RedAsterisk />
                </template>
              </v-text-field>
            </template>
            <business-date-picker
              v-model="item.planned_ship_date"
              no-title
              scrollable
              :min="getMinShipDate()"
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="item.planned_ship_date = null"
              >
                Clear
              </v-btn>
            </business-date-picker>
          </v-menu>
        </v-col>
        <!-- <v-col cols="3">
          <v-text-field
            v-model="item.planned_ship_time"
            type="time"
            :rules="[(v) => !!v || 'Ship Time is required']"
          >
            <template slot="label">
              Ship Time<RedAsterisk />
            </template>
          </v-text-field>
        </v-col> -->
      </v-row>
      <v-row v-if="!item.id">
        <v-col class="pb-0">
          <span>Note</span>
        </v-col>
      </v-row>
      <v-row v-if="!item.id">
        <v-col class="pt-0">
          <v-textarea
            v-model="item.note_text"
            outlined
            rows="3"
          />
        </v-col>
      </v-row>
      <job-form
        v-show="false"
        ref="jobForm"
        :is-supervisor="false"
        :is-client="false"
        :is-sub-class="true"
        :is-show-pending="true"
        :is-job-name="false"
        :is-address="false"
        @success="jobSuccess()"
      />
      <production-schedule-job-update-form
        v-show="false"
        ref="updateJobForm"
        @success="get(item.id)"
      />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import { addBusinessDays } from '@/helpers/BusinessDateHelper';
import BusinessDatePicker from '@/components/elements/BusinessDatePicker.vue';
import JobForm from '@/components/forms/jobs/JobForm';
import ProductionScheduleJobUpdateForm from '@/components/forms/productionSchedules/ProductionScheduleJobUpdateForm';

export default {
  components: {
    BusinessDatePicker,
    JobForm,
    ProductionScheduleJobUpdateForm,
  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      inventory_class_id: 6,
      job_id: null,
      wo_number: null,
      window_verticals: null,
    //   patio_doors: 0,
    //   euro_doors: 0,
      production_backlog: null,
      shipping_backlog: null,
      sp_po_number: null,
      sp_note_status_id: 3,
      sp_note: null,
      su_po_number: null,
      su_note_status_id: 3,
      su_note: null,
      sg_po_number: null,
      sg_note_status_id: 3,
      sg_note: null,
      glass_required_by: null,
      planned_ship_date: null,
      production_completion_date: null,
      production_completion_time: '07:00',
      note_text: null,
      location_id: null,
      sub_class_id: null,
      planned_ship_time: '00:00',
    },

    jobs: [],
    noteStatuses: [],
    // poNumbers: [],
    sgPoNumbers: [],
    suPoNumbers: [],
    spPoNumbers: [],
    roles: [],
    locations: [],

    noteStatusIdShort: 2,
    dateMenuRequiredBy: false,
    dateMenuShipDate: false,
    dateMenuCompletionDate: false,
    isDisabled: true,
    isDisabledVertical: false,
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdProdAdmin: 22,
    isUpdate: false,
    windowsSum: 0,

    subClassIdCornerPost: 2,
    subClassIdEuroDoor: 3,
    subClassIdCommercialWindows: 5,
    subClassIdCommercialDoors: 7,
    isManual: 0,

    loadingJob: false,
    loadingSgPoNumbers: false,
    loadingSuPoNumbers: false,
    loadingSpPoNumbers: false,

    statusIdInProgress: 1,
    statusIdCompleted: 2,
    statusIdOnHand: 3,

    locationId14Precidio: 3,
    locationId300Chrislea: 8,

    isSealedUnitOverbooked: false,
    sealedUnitOverbookedMessage: '',
    isCheckingSealedUnitCount: false,
    isSealedUnitCountChecked: false,
    isSubmitting: false,
    maximumSealedUnitsAllowedPerDay: 300,
    originalGlassRequiredByDate: null,
    isUpdatingRelatedScheduleDates: false,

    today: new Date().toISOString().substr(0, 10),

  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
      holidaysDateToNameMap: (state) => state.holidaysDateToNameMap,
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    isCommercialDoors() {
      return this.item && this.item.sub_class_id === this.subClassIdCommercialDoors;
    },
    isCommercialWindows() {
      return this.item && this.item.sub_class_id === this.subClassIdCommercialWindows;
    },
    sealedUnitOverbookedErrorMessages() {
      if (!this.isSealedUnitOverbooked) return [];
      return [this.sealedUnitOverbookedDateMessage];
    },
    sealedUnitOverbookedDateMessage() {
      if (!this.isSealedUnitOverbooked) return null;
      const overbookedDate = this.item && this.item.glass_required_by
        ? moment(this.item.glass_required_by, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'this date';
      return `Sealed Units overbooked for ${overbookedDate}`;
    },
    sealedUnitOverbookedChipMessage() {
      if (!this.isSealedUnitOverbooked) return null;
      return this.sealedUnitOverbookedMessage || this.sealedUnitOverbookedDateMessage;
    },
    sealedUnitNotOverbookedChipMessage() {
      if (!this.isSealedUnitCountChecked || this.isSealedUnitOverbooked) return null;
      return 'Sealed Unit capacity OK';
    },
    sealedUnitStatusChipMessage() {
      if (this.isCheckingSealedUnitCount) return 'Checking Sealed Units...';
      if (this.isSealedUnitOverbooked) return this.sealedUnitOverbookedChipMessage;
      return this.sealedUnitNotOverbookedChipMessage;
    },
    sealedUnitStatusChipClass() {
      if (this.isCheckingSealedUnitCount) return 'sealed-unit-status-chip--checking';
      if (this.isSealedUnitOverbooked) return 'sealed-unit-status-chip--overbooked';
      if (this.isSealedUnitCountChecked) return 'sealed-unit-status-chip--available';
      return '';
    },
    sealedUnitStatusChipIcon() {
      if (this.isCheckingSealedUnitCount) return 'mdi-timer-sand';
      if (this.isSealedUnitOverbooked) return 'mdi-alert-circle';
      return 'mdi-check-circle';
    },
    productionCompletionDateRules() {
      return [
        (v) => !!v || 'Production Completion Date is required',
      ];
    },
    glassRequiredByRules() {
      return [
        (v) => !!v || 'Glass Req. By is required',
      ];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    // 'item.inventory_class_id': function (value) {
    //   if (value == null) return;
    //   this.getJobs();
    //   this.getLocations();
    // },
    // eslint-disable-next-line func-names
    'item.job_id': function (value) {
      this.isDisabledVertical = false;
      if (value == null) return;

      const job = this.jobs.find((x) => parseInt(x.id, 10) === parseInt(value, 10));
      if (job == null) return;

      if (job.sub_class) {
        this.item.sub_class_id = job.sub_class.id;

        if (job.sub_class.id === this.subClassIdEuroDoor) {
          this.item.window_verticals = 0;
          this.item.patio_doors = 0;
          const locationId14Precidio = 3;
          this.item.location_id = locationId14Precidio;
          this.isDisabledVertical = true;
        } else if (job.sub_class.id === this.subClassIdCornerPost) {
          const locationId14Precidio = 3;
          this.item.location_id = locationId14Precidio;
        }
      }

      this.getGlassPos();

      if (this.isUpdate) return;

      if (job.sub_class_id === this.subClassIdEuroDoor) {
        this.item.euro_doors = job.total_euro_doors ? job.total_euro_doors : 0;
        this.item.window_verticals = 0;
        this.item.patio_doors = 0;
      } else {
        this.item.window_verticals = job.total_windows ? job.total_windows : 0;
        this.item.patio_doors = job.total_patio_doors ? job.total_patio_doors : 0;
        this.item.euro_doors = 0;
      }
      this.item.wo_number = job.code;

      this.getPatioDoors(job.code);
    },
    // eslint-disable-next-line func-names
    'item.sp_po_number': function (value) {
      if (value == null) {
        this.item.sp_note_status_id = null;
        this.item.sp_note = null;
      }
    },
    // eslint-disable-next-line func-names
    'item.su_po_number': function (value) {
      if (value == null) {
        this.item.su_note_status_id = null;
        this.item.su_note = null;
        if (this.item && this.item.glass_required_by) {
          this.checkSealedUnitProductionCountForDate(this.item.glass_required_by);
        } else {
          this.resetSealedUnitOverbookedValidation();
        }
        return;
      }

      if (this.item && this.item.glass_required_by) {
        this.checkSealedUnitProductionCountForDate(this.item.glass_required_by);
      }
    },
    // eslint-disable-next-line func-names
    'item.sg_po_number': function (value) {
      if (value == null) {
        this.item.sg_note_status_id = null;
        this.item.sg_note = null;
      }
    },
    // eslint-disable-next-line func-names
    'item.planned_ship_date': function (value) {
      if (this.isUpdatingRelatedScheduleDates) return;
      if (value === null) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }

      let productionCompletionDate = this.item.production_completion_date;
      if (this.shouldMoveProductionCompletionDateForPlannedShipDate(productionCompletionDate, value)) {
        productionCompletionDate = value;
        this.item.production_completion_date = productionCompletionDate;
      }

      if (this.shouldMoveGlassRequiredByDateForProductionCompletionDate(this.item.glass_required_by, productionCompletionDate)) {
        this.item.glass_required_by = productionCompletionDate;
        this.checkSealedUnitProductionCountForDateIfChanged(this.item.glass_required_by);
      }
    },
  },
  created() {
    this.item = { ...this.itemDto };
    this.roles = this.user.roles.map((x) => x.id);
    this.isDisabled = !(this.roles.includes(this.userRoleIdAdmin) || this.roles.includes(this.userRoleIdApprover) || this.roles.includes(this.userRoleIdProdAdmin));
  },
  methods: {
    async init() {
      this.getNoteStatuses();
      this.getLocations();
      await this.$store.dispatch('getHolidays');
      await this.getJobs();
      this.getGlassPos();
    },

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.commercialSchedule.read(submitModel);
      if (!res || !res.data || res.data.length === 0) return;
      const firstIndex = 0;
      this.item = { ...this.itemDto, ...res.data[firstIndex] };
      this.$nextTick(() => {
        this.isUpdate = false;
      });
      // this.getGlassPos();
    },

    async getNoteStatuses() {
      this.noteStatuses = await this.$api.commercialScheduleNoteStatus.get();
    },

    async getJobs(jobCode) {
      this.loadingJob = true;
      const submitModel = {
        filters: {
          inventory_class_id: this.item.inventory_class_id, is_sub_class: 1, is_patio_doors: 1,
        },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.jobs = res;

      if (jobCode) {
        const job = this.jobs.find((x) => x.code === jobCode);
        if (job) {
          this.item.job_id = job.id;
        }
      }
      this.loadingJob = false;
    },

    // async getGlassPos() {
    //   if (!this.item.job_id) return;
    //   const job = this.jobs.find((x) => x.id === this.item.job_id);
    //   if (!job) return;
    //   const res = await this.$api.glass.get(`po-numbers/${this.item.inventory_class_id}/${job.code}`);
    //   if (!res) {
    //     this.poNumbers = [];
    //     return;
    //   }
    //   this.poNumbers = res;
    //   const firstIndex = 0;
    //   const secondIndex = 1;
    //   const thirdIndex = 2;
    //   if (!this.item.sp_po_number && !this.item.su_po_number && !this.item.sg_po_number) {
    //     if (this.poNumbers.length === 1) {
    //       this.item.sp_po_number = this.poNumbers[firstIndex];
    //       this.item.su_po_number = this.poNumbers[firstIndex];
    //       this.item.sg_po_number = this.poNumbers[firstIndex];
    //     } else if (this.poNumbers.length === 2) {
    //       this.item.sp_po_number = this.poNumbers[firstIndex];
    //       this.item.su_po_number = this.poNumbers[secondIndex];
    //       this.item.sg_po_number = null;
    //     } else if (this.poNumbers.length >= 3) {
    //       this.item.sp_po_number = this.poNumbers[firstIndex];
    //       this.item.su_po_number = this.poNumbers[secondIndex];
    //       this.item.sg_po_number = this.poNumbers[thirdIndex];
    //     }
    //   }
    // },

    async getGlassPos() {
      this.getSingleGlassPos();
      this.getSealedUnitGlassPos();
      this.getSpandrelGlassPos();
    },

    async getSingleGlassPos() {
      if (!this.item.job_id) return;
      const job = this.jobs.find((x) => parseInt(x.id, 10) === parseInt(this.item.job_id, 10));
      if (!job) return;
      this.loadingSgPoNumbers = true;
      const res = await this.$api.glass.get(`po-numbers/single-glass/${this.item.inventory_class_id}/${job.code}`);
      this.loadingSgPoNumbers = false;
      if (!res) {
        this.sgPoNumbers = [];
        return;
      }
      this.sgPoNumbers = res;
      if (!this.item.sg_po_number && this.sgPoNumbers.length > 0) {
        this.item.sg_po_number = this.sgPoNumbers[0];
      }
      // this.poNumbers = res;
    },

    async getSealedUnitGlassPos() {
      if (!this.item.job_id) return;
      const job = this.jobs.find((x) => parseInt(x.id, 10) === parseInt(this.item.job_id, 10));
      if (!job) return;
      this.loadingSuPoNumbers = true;
      const res = await this.$api.glass.get(`po-numbers/sealed-unit-glass/${this.item.inventory_class_id}/${job.code}`);
      this.loadingSuPoNumbers = false;
      if (!res) {
        this.suPoNumbers = [];
        return;
      }
      this.suPoNumbers = res;
      if (!this.item.su_po_number && this.suPoNumbers.length > 0) {
        this.item.su_po_number = this.suPoNumbers[0];
      }
      // this.poNumbers = res;
    },

    async getSpandrelGlassPos() {
      if (!this.item.job_id) return;
      const job = this.jobs.find((x) => parseInt(x.id, 10) === parseInt(this.item.job_id, 10));
      if (!job) return;
      this.loadingSpPoNumbers = true;
      const res = await this.$api.glass.get(`po-numbers/spandrel-glass/${this.item.inventory_class_id}/${job.code}`);
      this.loadingSpPoNumbers = false;
      if (!res) {
        this.spPoNumbers = [];
        return;
      }
      this.spPoNumbers = res;
      if (!this.item.sp_po_number && this.spPoNumbers.length > 0) {
        this.item.sp_po_number = this.spPoNumbers[0];
      }
      // this.poNumbers = res;
    },

    async getLocations() {
      const locations = await this.$api.location.getList();
      this.locations = locations.filter((x) => x.id === this.locationId300Chrislea || x.id === this.locationId14Precidio);
    },

    async submit() {
      if (!this.item) return false;
      if (this.businessRulesGetBoolean('Sealed Unit Overbooking Check') && this.isCheckingSealedUnitCount) {
        this.$bus.$emit('showError', 'Checking sealed unit count, please wait.');
        return false;
      }
      if (this.businessRulesGetBoolean('Sealed Unit Overbooking Check') && this.isSealedUnitOverbooked) {
        this.$bus.$emit('showError', 'Sealed unit is overbooked, please select another Glass Required By Date.');
        return false;
      }
      this.isSubmitting = true;
      try {
        let res;
        if (this.item.id) {
          res = await this.$api.commercialSchedule.update(this.item);
        } else {
          res = await this.$api.commercialSchedule.store(this.item);
        }

        if (!res) {
          this.$bus.$emit('showError');
          return false;
        }
        if (res !== true) {
          this.$bus.$emit('showError', res);
          return false;
        }

        this.$bus.$emit('showSuccess');
        this.originalGlassRequiredByDate = this.item.glass_required_by;
        this.$emit('success');
        return res;
      } finally {
        this.isSubmitting = false;
      }
    },

    async open(id) {
      this.$refs.dialogBox.open();
      this.resetSealedUnitOverbookedValidation();
      if (id) {
        this.isUpdate = true;
        this.item.id = id;
        this.isManual = 1;
        await this.get(id);
        this.originalGlassRequiredByDate = this.item.glass_required_by;
        this.setDefaultFields();
      } else {
        this.item = { ...this.itemDto };
        this.originalGlassRequiredByDate = null;

        this.isManual = 0;
      }
      this.init();
      if (!id) {
        this.item.production_completion_time = '07:00';
        this.item.planned_ship_time = '00:00';
        this.item.sp_note_status_id = 3;
        this.item.su_note_status_id = 3;
        this.item.sg_note_status_id = 3;
      }
    },

    async openJobForm() {
      const res = await this.$api.job.get('generate-manual-code');
      if (!res) return;
      this.$refs.jobForm.open();
      this.$nextTick(() => {
        this.$refs.jobForm.item.code = res;
        this.$refs.jobForm.item.is_manual = 1;
        if (this.item.inventory_class_id) this.$refs.jobForm.item.inventory_class_id = this.item.inventory_class_id;
      });
    },

    openUpdateJobForm() {
      this.$refs.updateJobForm.open(this.item);
    },

    async jobSuccess() {
      this.isManual = 1;
      await this.getJobs();
      const latestItemId = Math.max(...this.jobs.map((x) => x.id));
      if (latestItemId) { this.item.job_id = latestItemId; }
    },

    isJobManual() {
      const job = this.jobs.find((x) => parseInt(x.id, 10) === parseInt(this.item.job_id, 10));
      if (!job) return false;
      return job.is_manual;
    },

    getMinRequiredByDate() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },

    getMinDateProd() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },

    getMinShipDate() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },

    shouldMoveProductionCompletionDateForGlassRequiredBy(glassRequiredByDate, productionCompletionDate) {
      return !productionCompletionDate || glassRequiredByDate > productionCompletionDate;
    },

    shouldMoveGlassRequiredByDateForProductionCompletionDate(glassRequiredByDate, productionCompletionDate) {
      return !glassRequiredByDate || glassRequiredByDate > productionCompletionDate;
    },

    shouldMoveProductionCompletionDateForPlannedShipDate(productionCompletionDate, plannedShipDate) {
      return !productionCompletionDate || plannedShipDate < productionCompletionDate;
    },

    shouldMovePlannedShipDateForProductionCompletionDate(plannedShipDate, productionCompletionDate) {
      if (!plannedShipDate) return true;
      return plannedShipDate < productionCompletionDate;
    },

    setPlannedShipDateFromDateCascade(plannedShipDate) {
      this.isUpdatingRelatedScheduleDates = true;
      this.item.planned_ship_date = plannedShipDate;
      this.$nextTick(() => {
        this.isUpdatingRelatedScheduleDates = false;
      });
    },

    onProductionCompletionDateChange(value) {
      this.$refs.menuCompletionDate.save(this.item.production_completion_date);
      if (!value) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }

      if (this.shouldMoveGlassRequiredByDateForProductionCompletionDate(this.item.glass_required_by, value)) {
        this.item.glass_required_by = value;
        this.checkSealedUnitProductionCountForDateIfChanged(this.item.glass_required_by);
      }

      if (this.shouldMovePlannedShipDateForProductionCompletionDate(this.item.planned_ship_date, value)) {
        this.setPlannedShipDateFromDateCascade(value);
      }
    },

    onGlassRequiredByDateChange(value) {
      this.resetSealedUnitOverbookedValidation();
      if (!value) return;

      let productionCompletionDate = this.item.production_completion_date;
      if (this.shouldMoveProductionCompletionDateForGlassRequiredBy(value, productionCompletionDate)) {
        productionCompletionDate = value;
        this.item.production_completion_date = productionCompletionDate;
      }

      if (this.shouldMovePlannedShipDateForProductionCompletionDate(this.item.planned_ship_date, productionCompletionDate)) {
        this.setPlannedShipDateFromDateCascade(productionCompletionDate);
      }

      this.checkSealedUnitProductionCountForDateIfChanged(value);
    },

    checkSealedUnitProductionCountForDateIfChanged(date) {
      if (date === this.originalGlassRequiredByDate) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }
      this.checkSealedUnitProductionCountForDate(date);
    },

    async checkSealedUnitProductionCountForDate(date) {
      if (!this.businessRulesGetBoolean('Sealed Unit Overbooking Check')) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }
      if (!date) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }
      if (!this.item || parseInt(this.item.status_id, 10) === this.statusIdCompleted) return;
      await this.checkSealedUnitOverbooking(date);
    },

    async checkSealedUnitOverbooking(date) {
      const suPoNumber = this.item.su_po_number || null;
      this.isCheckingSealedUnitCount = true;
      this.isSealedUnitCountChecked = false;

      try {
        const overbookingCheck = await this.$api.glass.store({
          glass_required_by: date,
          po_number: suPoNumber,
        }, 'sealed-unit-overbooking-check');

        if (!this.item || this.item.glass_required_by !== date || (this.item.su_po_number || null) !== suPoNumber) return;

        if (!overbookingCheck) {
          this.$bus.$emit('showError', 'Unable to check sealed unit count. Please try again.');
          return;
        }

        const maximumSealedUnitsAllowedPerDay = overbookingCheck.maximum_sealed_units_allowed_per_day || this.maximumSealedUnitsAllowedPerDay;
        const totalSealedUnitCount = overbookingCheck.total_sealed_unit_count;

        this.maximumSealedUnitsAllowedPerDay = maximumSealedUnitsAllowedPerDay;

        if (overbookingCheck.is_overbooked) {
          this.isSealedUnitOverbooked = true;
          this.isSealedUnitCountChecked = true;
          const humanReadableDate = moment(date).format('MMMM Do, YYYY');
          this.sealedUnitOverbookedMessage = `Sorry, there will be ${totalSealedUnitCount} Sealed Units scheduled for ${humanReadableDate}. The maximum allowed is ${maximumSealedUnitsAllowedPerDay}. Please select a different date.`;
          this.$bus.$emit('showError', this.sealedUnitOverbookedMessage);
        } else {
          this.isSealedUnitOverbooked = false;
          this.sealedUnitOverbookedMessage = '';
          this.isSealedUnitCountChecked = true;
        }
      } finally {
        if (!this.item || (this.item.glass_required_by === date && (this.item.su_po_number || null) === suPoNumber)) {
          this.isCheckingSealedUnitCount = false;
        }
      }
    },

    resetSealedUnitOverbookedValidation() {
      this.isSealedUnitOverbooked = false;
      this.sealedUnitOverbookedMessage = '';
      this.isCheckingSealedUnitCount = false;
      this.isSealedUnitCountChecked = false;
    },

    setDefaultFields() {
      if (!this.item.location_id) {
        this.item.location_id = this.locationId300Chrislea;
      }
    }
  },
};
</script>

<style scoped>
.commercial-schedule-glass-required-by-field {
  flex: 0 0 220px;
  max-width: 220px;
}

.sealed-unit-status-chip {
  display: inline-flex;
  align-items: center;
  flex: 0 1 auto;
  width: fit-content;
  max-width: min(620px, 100%);
  min-width: 0;
  padding: 8px 12px;
  border-radius: 12px;
}

.sealed-unit-status-chip--checking {
  background-color: rgba(251, 191, 36, 0.16);
  color: #92400E;
}

.sealed-unit-status-chip--overbooked {
  background-color: rgba(244, 67, 54, 0.12);
  color: #B71C1C;
}

.sealed-unit-status-chip--available {
  background-color: rgba(76, 175, 80, 0.14);
  color: #1B5E20;
}

.sealed-unit-status-chip__icon {
  margin-right: 6px;
  font-size: 20px !important;
}

.sealed-unit-status-chip--checking .sealed-unit-status-chip__icon {
  color: #92400E !important;
}

.sealed-unit-status-chip--overbooked .sealed-unit-status-chip__icon {
  color: #B71C1C !important;
}

.sealed-unit-status-chip--available .sealed-unit-status-chip__icon {
  color: #1B5E20 !important;
}

.sealed-unit-status-chip span {
  font-size: 14px !important;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: break-word;
}
</style>
